import { createContext, useContext } from "react";

export type StepperContextType = {
    step: number;
    canGoBack: boolean;
    canGoForward: boolean;
    goBack: () => void;
    goForward: () => void;
};

export const StepperContext = createContext<StepperContextType | null>(null);

export function useStepperContext(): StepperContextType {
    const context = useContext(StepperContext);
    if (!context) {
        throw new Error("useStepperContext must be used within a StepperContext.Provider");
    }
    return context;
}
